import { useEffect, useState } from 'react';
import { crnc } from '../services/webb-utilities';

import { GetAuthUser } from '../services/user-accounts';
import { GetBaseAccount, GetAccountBalance } from '../services/user-accounts';

export default function UserBalanceCard() {

  const asset = GetAuthUser();

  const [loading,setLoading]=useState(false);
  const [data,setData]=useState({acbl:0, mots: '***'});

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);

        var acid = (await GetBaseAccount(JSON.stringify({
          body: {
            usid: asset.usid,
            form: asset.form,
          },
          user: {usid: asset.usid, form: asset.form}
        }))).data
        console.log (acid)
        setData((await GetAccountBalance(JSON.stringify({ 
          body: {
            acid: acid,
            usid: asset.usid,
            form: asset.form
          },
          user: {usid: asset.usid, form: asset.form}
        })
        )).data);

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  return (
    <>
    <div className="card rounded-wd bg-primary text-white" >
      <div className="row g-0">

        <div className="col">
          <div className="card-body">
            <p className="lead fw-bold m-0 p-0">{asset.name}</p>
            <p className="m-0 p-0">
              <small className="text-light">{asset.mmid}</small>
            </p>
          </div>
        </div>

        <div className="text-end" style={{width:"fit-content"}}>
          <div className="card-body ps-0">
            <p className="lead fw-bold m-0 p-0">{ loading ? 0 : crnc(data.acbl)}</p>
            <p className="m-0 p-0">
              <small className="text-light">Balance</small>
            </p>
          </div>
        </div>

      </div>
    </div>


    </>
  )
}